import ResetPasswordForm from "./ResetPasswordForm";

import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import PageHeader from "@/components/PageHeader";
import { PATH_ROOT } from "@/constants";
import { User } from "lucide-react";
import PageContent from "@/components/PageContent";

const ResetPasswordAuthorized = () => {
  const { t } = useTranslation();
  const breadcrumbItems = useMemo(
    () => [
      { label: t("breadcrumb.home"), href: PATH_ROOT },
      { label: t("resetPassword.title") },
    ],
    [t],
  );

  return (
    <>
      <PageHeader breadcrumbItems={breadcrumbItems} />
      <PageContent
        icon={<User className="w-6 h-6 mr-3" />}
        title={t("resetPassword.title")}
      >
        <ResetPasswordForm />
      </PageContent>
    </>
  );
};

export default ResetPasswordAuthorized;
